// extracted by mini-css-extract-plugin
export var button = "_7w-7";
export var buttonRow = "_7w-6";
export var fadeIn = "_7w-1";
export var gradient = "_7w-0";
export var panel = "_7w-2";
export var panelIn = "_7w-3";
export var subtitle = "_7w-5";
export var title = "_7w-4";